import { SerializedStyles } from '@emotion/react'
import { FunctionComponent, HTMLAttributes } from 'react'
import useStyles from './styles'

export interface DivisorLineProps extends HTMLAttributes<HTMLDivElement> {
  css?: SerializedStyles
}

const DivisorLine: FunctionComponent<DivisorLineProps> = ({
  css,
  ...props
}) => {
  const { wrapper } = useStyles()

  return <div css={[wrapper, css]} {...props} />
}

export default DivisorLine
